export function ModulePage({ title }) {
  return (
    <section>
      <div className="page-heading">
        <div>
          <span className="eyebrow">Módulo</span>
          <h1>{title}</h1>
          <p>Contrato de rota e espaço de interface preparados para implementação incremental.</p>
        </div>
        <button type="button" className="primary">Adicionar</button>
      </div>
      <article className="panel">
        <div className="toolbar">
          <input aria-label={`Pesquisar em ${title}`} placeholder="Pesquisar" />
          <button type="button" className="secondary">Filtros</button>
        </div>
        <div className="empty-state">Nenhum registro. Conecte este módulo ao endpoint correspondente.</div>
      </article>
    </section>
  );
}

